const TABS = [
  { dow: "all", label: "XSMT", title: "XSMT" },
  { dow: 1, label: "Thứ 2", title: "XSMT Thứ 2" },
  { dow: 2, label: "Thứ 3", title: "XSMT Thứ 3" },
  { dow: 3, label: "Thứ 4", title: "XSMT Thứ 4" },
  { dow: 4, label: "Thứ 5", title: "XSMT Thứ 5" },
  { dow: 5, label: "Thứ 6", title: "XSMT Thứ 6" },
  { dow: 6, label: "Thứ 7", title: "XSMT Thứ 7" },
  { dow: 0, label: "CN", title: "XSMT Chủ nhật" },
];

const COLUMN_ORDER = {
  0: ["khanh-hoa", "kon-tum", "thua-thien-hue"],
  1: ["thua-thien-hue", "phu-yen"],
  2: ["dak-lak", "quang-nam"],
  3: ["da-nang", "khanh-hoa"],
  4: ["binh-dinh", "quang-tri", "quang-binh"],
  5: ["gia-lai", "ninh-thuan"],
  6: ["da-nang", "quang-ngai", "dak-nong"],
};

const PROVINCES = {
  "binh-dinh": ["Bình Định", "23"],
  "quang-tri": ["Quảng Trị", "35"],
  "quang-binh": ["Quảng Bình", "32"],
  "da-nang": ["Đà Nẵng", "24"],
  "khanh-hoa": ["Khánh Hòa", "28"],
  "dak-lak": ["Đắc Lắc", "25"],
  "quang-nam": ["Quảng Nam", "34"],
  "thua-thien-hue": ["Thừa Thiên Huế", "36"],
  "phu-yen": ["Phú Yên", "31"],
  "kon-tum": ["Kon Tum", "29"],
  "quang-ngai": ["Quảng Ngãi", "33"],
  "dak-nong": ["Đắc Nông", "26"],
  "gia-lai": ["Gia Lai", "27"],
  "ninh-thuan": ["Ninh Thuận", "30"],
};

const PRIZE_ROWS = [
  { label: "G8", key: "prize8", row: "g8", div: "v-g8", nc: 2, slots: 1 },
  { label: "G7", key: "prize7", row: "", div: "v-g7", nc: 3, slots: 1 },
  { label: "G6", key: "prize6", row: "", div: "v-g6", nc: 4, slots: 3, indexed: true },
  { label: "G5", key: "prize5", row: "", div: "v-g5", nc: 4, slots: 1 },
  { label: "G4", key: "prize4", row: "", div: "v-g4", nc: 5, slots: 7, indexed: true },
  { label: "G3", key: "prize3", row: "", div: "v-g3", nc: 5, slots: 2, indexed: true },
  { label: "G2", key: "prize2", row: "", div: "v-g2", nc: 5, slots: 1 },
  { label: "G1", key: "prize1", row: "", div: "v-g1", nc: 5, slots: 1 },
  { label: "ĐB", key: "specialPrize", row: "gdb", div: "v-gdb", nc: 6, slots: 1 },
];

const TITLES = [
  (date, rel) => `XSMT - Xổ số miền Trung ${rel === "today" ? "hôm nay " : rel === "yesterday" ? "hôm qua " : ""}${date}`,
  (date, rel) => `KQXSMT - Xổ số đài miền Trung ${rel === "ereyesterday" ? "hôm kia " : ""}${date}`,
  (date) => `XSMTR - XSKT Miền Trung ${date}`,
  (date) => `SXMTR - So xo mien Trung ${date}`,
  (date) => `SXMT - SX miền Trung ${date}`,
  (date) => `XS MTRUNG - XS miền Trung ${date}`,
  (date) => `XSKTMT - Xổ số kiến thiết miền Trung ${date}`,
];

function esc(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function weekdayPhrase(dow) {
  return dow === 0 ? "chủ nhật" : `thứ ${dow + 1}`;
}

function layoutOf(count) {
  if (count >= 4) return { wrap: "four-city", col: "colfourcity" };
  if (count <= 2) return { wrap: "two-city", col: "coltwocity" };
  return { wrap: "three-city", col: "colthreecity" };
}

export function stationFrom(item) {
  const code = item?.province?.code || item?.provinceCode || "";
  if (!code) return null;
  const meta = PROVINCES[code];
  const apiName = item?.province?.name || item?.provinceName || code;
  return {
    code,
    name: meta ? meta[0] : apiName,
    pid: meta ? meta[1] : "",
    prizes: item?.prizes || {},
  };
}

export function orderStations(stations, dow) {
  const order = COLUMN_ORDER[dow] || [];
  return [...stations].sort((a, b) => {
    const left = order.indexOf(a.code);
    const right = order.indexOf(b.code);
    return (left < 0 ? 99 : left) - (right < 0 ? 99 : right);
  });
}

function pairOf(value) {
  const digits = String(value ?? "").replace(/\D/g, "");
  if (digits.length < 2) return null;
  return digits.slice(-2);
}

function pairsOf(prizes) {
  const out = [];
  PRIZE_ROWS.forEach((row) => {
    (prizes?.[row.key] || []).forEach((value) => {
      const pair = pairOf(value);
      if (pair) out.push({ pair, special: row.key === "specialPrize" });
    });
  });
  return out;
}

function lotoHtml(stations) {
  const columns = stations.map((station) => {
    const buckets = Array.from({ length: 10 }, () => new Map());
    pairsOf(station.prizes).forEach(({ pair, special }) => {
      const head = Number(pair[0]);
      const tail = pair[1];
      const entry = buckets[head].get(tail) || { count: 0, special: false };
      entry.count += 1;
      if (special) entry.special = true;
      buckets[head].set(tail, entry);
    });
    return buckets.map((bucket) =>
      [...bucket.entries()]
        .sort((a, b) => a[0].localeCompare(b[0]))
        .map(([digit, entry]) => {
          const sup = entry.count > 1 ? `<sup>${entry.count}</sup>` : "";
          const body = `${digit}${sup}`;
          return entry.special ? `<span class="clnote">${body}</span>` : body;
        })
        .join(", ")
    );
  });

  const heads = stations.map((station) => `<th>${esc(station.name)}</th>`).join("");
  const rows = [];
  for (let head = 0; head < 10; head += 1) {
    const cells = columns.map((column) => `<td class="v-loto-dau-${head}">${column[head]}</td>`).join("");
    rows.push(`<tr><td class="clnote bold">${head}</td>${cells}</tr>`);
  }
  return `<tr class="header"><th class="first">Đầu</th>${heads}</tr>${rows.join("")}`;
}

function prizeCell(station, row) {
  const values = (station.prizes?.[row.key] || []).map((value) => String(value));
  const count = Math.max(row.slots, values.length);
  const divs = [];
  for (let index = 0; index < count; index += 1) {
    const cls = row.indexed ? `${row.div}-${index}` : row.div;
    divs.push(`<div data-nc="${row.nc}" class="${cls} ">${values[index] != null ? esc(values[index]) : ""}</div>`);
  }
  return `<td>${divs.join("")}</td>`;
}

function resultTable(stations) {
  const { wrap, col } = layoutOf(stations.length);
  const heads = stations
    .map(
      (station) =>
        `<th${station.pid ? ` data-pid="${esc(station.pid)}"` : ""}>${esc(station.name)}</th>`
    )
    .join("");
  const body = PRIZE_ROWS.map((row) => {
    const cells = stations.map((station) => prizeCell(station, row)).join("");
    return `<tr${row.row ? ` class="${row.row}"` : ""}><td>${row.label}</td>${cells}</tr>`;
  }).join("");
  return `<div data-id="kq" data-zoom="0" data-hover="1" class="${wrap}" data-region="2"><table class="${col} colgiai extendable"><tbody><tr class="gr-yellow"><th class="first"></th>${heads}</tr>${body}</tbody></table>`;
}

function digitsForm(index) {
  const name = `showed-digits-${index + 1}`;
  return `<div class="control-panel"><form class="digits-form"><label class="radio" data-value="0"><input type="radio" name="${name}" value="0" checked><b></b><span></span></label><label class="radio" data-value="2"><input type="radio" name="${name}" value="2"><b></b><span></span></label><label class="radio" data-value="3"><input type="radio" name="${name}" value="3"><b></b><span></span></label></form></div>`;
}

function dayTitle(index, dash, rel) {
  const format = TITLES[index] || TITLES[TITLES.length - 1];
  return format(dash, rel);
}

function subtitle(index, dow) {
  const phrase = `XSMT ${weekdayPhrase(dow)}`;
  const link = `<span class="sub-title">${esc(phrase)}</span>`;
  if (index !== 0) return link;
  return `<span class="sub-title">XSMT</span> » ${link}`;
}

function statCells(items, unit) {
  const rows = [];
  for (let index = 0; index < items.length; index += 5) {
    const cells = items
      .slice(index, index + 5)
      .map(
        (item) =>
          `<td><b class=" clnote">${esc(item.label)}</b> <span class="dsp-mobile-block">${esc(item.count)} ${unit}</span></td>`
      )
      .join("");
    rows.push(`<tr>${cells}</tr>`);
  }
  return rows.join("");
}

function statTable(title, items, unit, id) {
  return `<div${id ? ` id="${id}"` : ""}><div class="statistic-box mag5"><table class="with-border"><tr><th colspan="5"><div class="">${title}</div></th></tr>${statCells(items, unit)}</table></div></div>`;
}

function digitItems(counts) {
  return counts
    .map((count, digit) => ({ label: String(digit), count }))
    .sort((a, b) => b.count - a.count || a.label.localeCompare(b.label));
}

function statsBlock(stats) {
  if (!stats) return "";
  const hot = stats.hot.map((item) => ({ label: item.pair, count: item.count }));
  const cold = stats.cold.map((item) => ({ label: item.pair, count: item.count }));
  const gan = stats.gan.map((item) => ({ label: item.pair, count: item.gap }));
  return `<div class="box statistic-summary mag5-0" id="thong-ke-nhanh"><div class="regional-title mag5-0 bold txt-center">Thống kê xổ số Miền Trung 30 lần quay</div><div class="txt-center"></div>${statTable('Bộ số xuất hiện <b class="clnote">nhiều</b> nhất', hot, "lần", "data-ve-nhieu")}${statTable('Bộ số xuất hiện <b class="clnote">ít</b> nhất trong 30 lần quay', cold, "lần", "data-ve-it")}${statTable('Bộ số lâu chưa về nhất (<span class="title-a">lô tô gan</span>)', gan, "lượt", "data-gan")}${statTable("Thống kê đầu số trong 30 lần quay", digitItems(stats.heads), "lần")}${statTable("Thống kê đuôi số trong 30 lần quay", digitItems(stats.tails), "lần")}</div>`;
}

export function buildStats(days) {
  const freq = new Map();
  const lastIndex = new Map();
  const heads = Array(10).fill(0);
  const tails = Array(10).fill(0);
  days.forEach((day, index) => {
    const seen = new Set();
    (day.rows || []).forEach((row) => {
      pairsOf(row?.prizes).forEach(({ pair }) => {
        freq.set(pair, (freq.get(pair) || 0) + 1);
        heads[Number(pair[0])] += 1;
        tails[Number(pair[1])] += 1;
        seen.add(pair);
      });
    });
    seen.forEach((pair) => {
      if (!lastIndex.has(pair)) lastIndex.set(pair, index);
    });
  });
  const ranked = [];
  for (let index = 0; index < 100; index += 1) {
    const pair = String(index).padStart(2, "0");
    ranked.push({ pair, count: freq.get(pair) || 0 });
  }
  const hot = [...ranked].sort((a, b) => b.count - a.count || a.pair.localeCompare(b.pair)).slice(0, 10);
  const cold = [...ranked]
    .filter((item) => item.count > 0)
    .sort((a, b) => a.count - b.count || a.pair.localeCompare(b.pair))
    .slice(0, 10);
  const gan = [];
  for (let index = 0; index < 100; index += 1) {
    const pair = String(index).padStart(2, "0");
    const gap = lastIndex.has(pair) ? lastIndex.get(pair) : days.length;
    if (gap > 0) gan.push({ pair, gap });
  }
  gan.sort((a, b) => b.gap - a.gap || a.pair.localeCompare(b.pair));
  return { hot, cold, gan: gan.slice(0, 10), heads, tails };
}

function relative(date, today, yesterday, ereyesterday) {
  if (date === today) return "today";
  if (date === yesterday) return "yesterday";
  if (date === ereyesterday) return "ereyesterday";
  return "";
}

export function renderPage({ dow, days, stats, today, yesterday, ereyesterday }) {
  const tabs = `<ul class="tab-panel">${TABS.map((tab) => {
    const active = tab.dow === dow ? " class='active'" : "";
    const title = tab.dow === "all" ? "" : ` title="${esc(tab.title)}"`;
    return `<li${active} data-dow="${tab.dow}"><a${title}>${tab.label}</a></li>`;
  }).join("")}</ul>`;

  const boxes = days
    .map((day, index) => {
      const { col } = layoutOf(day.stations.length);
      const rel = relative(day.date, today, yesterday, ereyesterday);
      const statsHtml = index === 0 ? statsBlock(stats) : "";
      return `<div class="box"><div class="regional-title clearfix"><h2>${esc(dayTitle(index, day.dash, rel))}</h2><div>${subtitle(index, day.dow)}</div></div><div id="load_kq_mt_${index}">${resultTable(day.stations)}${digitsForm(index)}</div><div data-id="dd" class="col-firstlast ${col} colgiai"><table class="firstlast-mn bold"><tbody>${lotoHtml(day.stations)}</tbody></table></div></div>${statsHtml}</div>`;
    })
    .join("");

  return `${tabs}${boxes}`;
}
